import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { CreateFolderButton } from '../../components/CreateFolder/button';
import { CreateFolderForm } from '../../components/CreateFolder/form';
export function CreateFolderContainer(_ref) {
  var isCreating = _ref.isCreating,
      onCreate = _ref.onCreate;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      showForm = _React$useState2[0],
      setShowForm = _React$useState2[1];

  var handleCreate = function handleCreate(name) {
    setShowForm(false);

    if (onCreate) {
      onCreate(name);
    }
  };

  return showForm || isCreating ? /*#__PURE__*/React.createElement(CreateFolderForm, {
    isCreating: isCreating,
    onCreate: handleCreate,
    onCancel: function onCancel() {
      return setShowForm(false);
    }
  }) : /*#__PURE__*/React.createElement(CreateFolderButton, {
    onClick: function onClick() {
      return setShowForm(true);
    }
  });
}